import React from "react";
import { useTranslation } from "react-i18next";
import { addAdminComment } from "features/Agreements/AgreementsList/actions";
import { Table, Form, ModalBuilder, ActionMenu } from "@redriver/cinnamon";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { DropdownItem } from "semantic-ui-react";
import { NonPropagatingTextArea } from "features/../../../shared/components/forms/NonPropagatingField";

const AddAdminComment = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");

  let { sheetId } = sheet;
  return (
    <ModalBuilder
      withForm
      initialData={{ comment: sheet.adminComment }}
      submitAction={addAdminComment}
      submitParams={{ sheetId }}
      onSubmitted={onSubmitted}
      renderError={false}
      renderSubmitting={false}
      renderTrigger={(trigger) => (
        <DropdownItem onClick={trigger}>
          {t("SheetActions.AddComment.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps, formProps) => (
        <TranslatedModal.Edit
          {...modalProps}
          header={t("SheetActions.AddComment.HeaderText")}
        >
          <Form {...formProps}>
            <NonPropagatingTextArea
              field="comment"
              label={t("SheetActions.AddComment.Comment")}
              className="full-width"
              rows={4}
            />
          </Form>
        </TranslatedModal.Edit>
      )}
    />
  );
};

export default AddAdminComment;
